// extracted by mini-css-extract-plugin
export var blockVideosGrid = "VideosGrid-module--block-videos-grid---noBX";
export var blockVideosGridNoPaddingTop = "VideosGrid-module--block-videos-grid-no-padding-top--3-QdL";
export var blockVideosGridNoPaddingBottom = "VideosGrid-module--block-videos-grid-no-padding-bottom--TPiWm";
export var blockVideosGridItem = "VideosGrid-module--block-videos-grid-item--31xGP";
export var blockVideosGridItemHeading = "VideosGrid-module--block-videos-grid-item-heading--2PVcN";